// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The tree view on the TA / premium admin pages */
.tree {
  background-color: #e5e5e5;
  margin-bottom: 0.25rem;
}

/* make the tree title and open close button bigger */
.tree .title span {
  font-weight: bold;
  font-size: 20px;
}

/* Make the open close button in the title aligned to the right */
.tree .title .largeOpenClose.openClose {
  width: 2rem;
  text-align: right;
  margin-right: 2.5rem;
}

/* Style the icon svg for the list */
.tree .treeRow .icon {
  width: 12px;
  height: 16px;
  display: inline-block;
  margin-bottom: 3px;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

/* We don't want padding on the ul elements
 * because it messes up with the background
 * color of the highlighting. we want the whole
 * row/group highlighting to cover the entire element
 * and not be indented */
ul.tree {
  padding-left: 0;
}
.tree ul {
  padding-left: 0;
}

/* get rid of all bullet points on the inner items */
.tree li {
  list-style-type: none;
}

/* Every row should have the +/- on the right */
.tree .treeRow {
  display: flex;
  justify-content: space-between;
  /* give some breathing room between each row */
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}

/* Make all open close buttons horizontally centered */
.tree .treeRow .openClose {
  margin-right: 1.95rem;
  width: 2rem;
  text-align: right;
}

/* Make the area right below the title have some padding on top */
.tree ul.topLevelGroups {
  padding-top: 1rem;
  /* If the tree becomes too tall, make it start scrolling */
  max-height: 40vh;
  overflow-y: scroll;
}

/* The group should have a gray box around it
 * The actual row the user clicked on should be slightly darker. The group is the highest level around the
 * 
 */
.tree .groupHighlight {
  background-color: #d7d7d7;
}
/* The clicked row should be slightly darker */
.tree div.highlight {
  background-color: #b6b6b6;
}

.tree li .treeRow {
  padding-left: 2rem;
}

.tree li li .treeRow {
  padding-left: 2rem;
}

.tree li li li .treeRow {
  padding-left: 4rem;
}

.tree li li li li .treeRow {
  padding-left: 6rem;
}

.tree li li li li li .treeRow {
  padding-left: 8rem;
}

.tree li li li li li li .treeRow {
  padding-left: 10rem;
}

.tree li li li li li li .treeRow {
  padding-left: 12rem;
}

.tree li li li li li li li .treeRow {
  padding-left: 14rem;
}

.tree li li li li li li li li .treeRow {
  padding-left: 16rem;
}

.tree li li li li li li li li li .treeRow {
  padding-left: 18rem;
}

.tree li li li li li li li li li li .treeRow {
  padding-left: 20rem;
}

.tree li li li li li li li li li li li .treeRow {
  padding-left: 22rem;
}

.tree li li li li li li li li li li li li .treeRow {
  padding-left: 24rem;
}

/***** NEW TREE STYLING *****/
treecontrol ul {
  background-color: #e5e5e5;
  margin-bottom: 1px;
}
/* Make the title of each tree in bold */
treecontrol > ul > li > .treeRow > .iconAndName > .tree-label {
  font-size: 20px;
  font-weight: bold;
  color: black;
}

treecontrol > ul > li > .treeRow > .openClose > span {
  font-weight: bold;
  font-size: 20px;
  color: black;
}

/* Every row should have the +/- on the right */
treecontrol .treeRow {
  display: flex;
  justify-content: space-between;
  /* give some breathing room between each row */
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  width: 100%;
}

/* Make the container for the tree scrollable */
treecontrol > ul > li > treeitem > ul {
  max-height: 500px;
  overflow: auto;
}

/* Make the second level of the tree left aligned with the title */
treecontrol > ul > li > treeitem > ul > li {
  padding: 0;
}

body treecontrol li {
  line-height: initial;
}

body treecontrol li img {
  margin-right: 5px;
}

treecontrol.tree-classic li .tree-label {
  font-size: 12px;
}

treecontrol.tree-classic li .tree-selected {
  background-color: #b6b6b6;
  font-weight: normal;
}

/* Overriding a default style on the tree */
body treecontrol li {
  padding: initial;
}

treecontrol li .treeRow {
  padding-left: 2rem;
}

treecontrol li li .treeRow {
  padding-left: 2rem;
}

treecontrol li li li .treeRow {
  padding-left: 4rem;
}

treecontrol li li li li .treeRow {
  padding-left: 6rem;
}

treecontrol li li li li li .treeRow {
  padding-left: 8rem;
}

treecontrol li li li li li li .treeRow {
  padding-left: 10rem;
}

treecontrol li li li li li li li .treeRow {
  padding-left: 12rem;
}

treecontrol li li li li li li li li .treeRow {
  padding-left: 14rem;
}

treecontrol li li li li li li li li li .treeRow {
  padding-left: 16rem;
}

treecontrol li li li li li li li li li li .treeRow {
  padding-left: 18rem;
}

treecontrol li li li li li li li li li li li .treeRow {
  padding-left: 20rem;
}

treecontrol li li li li li li li li li li li li .treeRow {
  padding-left: 22rem;
}

treecontrol li li li li li li li li li li li li li .treeRow {
  padding-left: 24rem;
}

treecontrol > ul > li > .treeRow .tree-selected {
  background-color: grey;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/tree.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,qDAAqD;AACrD;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,iEAAiE;AACjE;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;;wBAIwB;AACxB;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,8BAA8B;EAC9B,8CAA8C;EAC9C,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,sDAAsD;AACtD;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA,iEAAiE;AACjE;EACE,iBAAiB;EACjB,0DAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE;AACF;EACE,yBAAyB;AAC3B;AACA,8CAA8C;AAC9C;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA,wCAAwC;AACxC;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,8BAA8B;EAC9B,8CAA8C;EAC9C,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* The tree view on the TA / premium admin pages */\n.tree {\n  background-color: #e5e5e5;\n  margin-bottom: 0.25rem;\n}\n\n/* make the tree title and open close button bigger */\n.tree .title span {\n  font-weight: bold;\n  font-size: 20px;\n}\n\n/* Make the open close button in the title aligned to the right */\n.tree .title .largeOpenClose.openClose {\n  width: 2rem;\n  text-align: right;\n  margin-right: 2.5rem;\n}\n\n/* Style the icon svg for the list */\n.tree .treeRow .icon {\n  width: 12px;\n  height: 16px;\n  display: inline-block;\n  margin-bottom: 3px;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n\n/* We don't want padding on the ul elements\n * because it messes up with the background\n * color of the highlighting. we want the whole\n * row/group highlighting to cover the entire element\n * and not be indented */\nul.tree {\n  padding-left: 0;\n}\n.tree ul {\n  padding-left: 0;\n}\n\n/* get rid of all bullet points on the inner items */\n.tree li {\n  list-style-type: none;\n}\n\n/* Every row should have the +/- on the right */\n.tree .treeRow {\n  display: flex;\n  justify-content: space-between;\n  /* give some breathing room between each row */\n  padding-top: 0.3rem;\n  padding-bottom: 0.3rem;\n}\n\n/* Make all open close buttons horizontally centered */\n.tree .treeRow .openClose {\n  margin-right: 1.95rem;\n  width: 2rem;\n  text-align: right;\n}\n\n/* Make the area right below the title have some padding on top */\n.tree ul.topLevelGroups {\n  padding-top: 1rem;\n  /* If the tree becomes too tall, make it start scrolling */\n  max-height: 40vh;\n  overflow-y: scroll;\n}\n\n/* The group should have a gray box around it\n * The actual row the user clicked on should be slightly darker. The group is the highest level around the\n * \n */\n.tree .groupHighlight {\n  background-color: #d7d7d7;\n}\n/* The clicked row should be slightly darker */\n.tree div.highlight {\n  background-color: #b6b6b6;\n}\n\n.tree li .treeRow {\n  padding-left: 2rem;\n}\n\n.tree li li .treeRow {\n  padding-left: 2rem;\n}\n\n.tree li li li .treeRow {\n  padding-left: 4rem;\n}\n\n.tree li li li li .treeRow {\n  padding-left: 6rem;\n}\n\n.tree li li li li li .treeRow {\n  padding-left: 8rem;\n}\n\n.tree li li li li li li .treeRow {\n  padding-left: 10rem;\n}\n\n.tree li li li li li li .treeRow {\n  padding-left: 12rem;\n}\n\n.tree li li li li li li li .treeRow {\n  padding-left: 14rem;\n}\n\n.tree li li li li li li li li .treeRow {\n  padding-left: 16rem;\n}\n\n.tree li li li li li li li li li .treeRow {\n  padding-left: 18rem;\n}\n\n.tree li li li li li li li li li li .treeRow {\n  padding-left: 20rem;\n}\n\n.tree li li li li li li li li li li li .treeRow {\n  padding-left: 22rem;\n}\n\n.tree li li li li li li li li li li li li .treeRow {\n  padding-left: 24rem;\n}\n\n/***** NEW TREE STYLING *****/\ntreecontrol ul {\n  background-color: #e5e5e5;\n  margin-bottom: 1px;\n}\n/* Make the title of each tree in bold */\ntreecontrol > ul > li > .treeRow > .iconAndName > .tree-label {\n  font-size: 20px;\n  font-weight: bold;\n  color: black;\n}\n\ntreecontrol > ul > li > .treeRow > .openClose > span {\n  font-weight: bold;\n  font-size: 20px;\n  color: black;\n}\n\n/* Every row should have the +/- on the right */\ntreecontrol .treeRow {\n  display: flex;\n  justify-content: space-between;\n  /* give some breathing room between each row */\n  padding-top: 0.3rem;\n  padding-bottom: 0.3rem;\n  width: 100%;\n}\n\n/* Make the container for the tree scrollable */\ntreecontrol > ul > li > treeitem > ul {\n  max-height: 500px;\n  overflow: auto;\n}\n\n/* Make the second level of the tree left aligned with the title */\ntreecontrol > ul > li > treeitem > ul > li {\n  padding: 0;\n}\n\nbody treecontrol li {\n  line-height: initial;\n}\n\nbody treecontrol li img {\n  margin-right: 5px;\n}\n\ntreecontrol.tree-classic li .tree-label {\n  font-size: 12px;\n}\n\ntreecontrol.tree-classic li .tree-selected {\n  background-color: #b6b6b6;\n  font-weight: normal;\n}\n\n/* Overriding a default style on the tree */\nbody treecontrol li {\n  padding: initial;\n}\n\ntreecontrol li .treeRow {\n  padding-left: 2rem;\n}\n\ntreecontrol li li .treeRow {\n  padding-left: 2rem;\n}\n\ntreecontrol li li li .treeRow {\n  padding-left: 4rem;\n}\n\ntreecontrol li li li li .treeRow {\n  padding-left: 6rem;\n}\n\ntreecontrol li li li li li .treeRow {\n  padding-left: 8rem;\n}\n\ntreecontrol li li li li li li .treeRow {\n  padding-left: 10rem;\n}\n\ntreecontrol li li li li li li li .treeRow {\n  padding-left: 12rem;\n}\n\ntreecontrol li li li li li li li li .treeRow {\n  padding-left: 14rem;\n}\n\ntreecontrol li li li li li li li li li .treeRow {\n  padding-left: 16rem;\n}\n\ntreecontrol li li li li li li li li li li .treeRow {\n  padding-left: 18rem;\n}\n\ntreecontrol li li li li li li li li li li li .treeRow {\n  padding-left: 20rem;\n}\n\ntreecontrol li li li li li li li li li li li li .treeRow {\n  padding-left: 22rem;\n}\n\ntreecontrol li li li li li li li li li li li li li .treeRow {\n  padding-left: 24rem;\n}\n\ntreecontrol > ul > li > .treeRow .tree-selected {\n  background-color: grey;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
